
export default {
  props: {
    variant: {
      type: String,
      default: '' // tertiary, quinary
    }
  },
  setup () {

  }
}
